export const HEADER_HEIGHT_LG = 172;
export const HEADER_HEIGHT_SM = 116;
